import React from 'react'
import { Box, Text, Icon } from '@chakra-ui/react'
import { FaExclamationTriangle } from 'react-icons/fa'
import Select, { SelectOption } from 'components/Select'
import { useTranslation } from 'react-i18next'

type Validations = {
  isInvalid: boolean
  isValid: boolean
  errorMessage?: string
  id: string
}

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  field: any
  validations: Validations
  defaultValue?: SelectOption
  options: SelectOption[]
  isRequired?: boolean
}

const CurrencySelector: React.FC<Props> = ({
  field,
  validations,
  defaultValue,
  options,
  isRequired,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Select
        {...field}
        {...validations}
        label={t('form.currency_field.label')}
        placeholder={t('form.currency_field.placeholder')}
        defaultValue={defaultValue}
        options={options}
        isRequired={isRequired}
      />
      <Box mt={2}>
        <Text fontSize="sm">{t('form.currency_field.hint_system')}</Text>
        <Text fontSize="sm" display="flex" alignItems="center" gap={1}>
          <Icon as={FaExclamationTriangle} />
          {t('form.currency_field.hint_no_change')}
        </Text>
      </Box>
    </>
  )
}

export default CurrencySelector
